export default __webpack_public_path__ + "9c5a7d7cb21872521e878c95e0bbb716.png";